import moment from 'moment'

import { TitleCell, TitleRow } from '../../../../components/ReusableComponents/Table'

const InvoicesTitleRow = ({ months }) => (
  <TitleRow style={{ position: 'sticky', top: 70 }}>
    <TitleCell>Id</TitleCell>
    <TitleCell>Hotel name</TitleCell>
    {months.map(m => (
      <TitleCell key={m}>{moment(m).format('MMM')}</TitleCell>
    ))}
  </TitleRow>
)

export default InvoicesTitleRow
